// Constants for different requests for current reducer
export default {
  mobilePatrols: 'MOBILE_PATROLS',
};
